import React from "react";
import { useTheme } from "styled-components";

import { Close } from "@ui/Assets/MyIcons";
import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { Props } from "./CustomDrawerHeader.types";
import * as Styled from "./CustomDrawerHeader.styled";

export const CustomDrawerHeader: React.FC<
  React.PropsWithChildren<Props>
> = props => {
  const theme = useTheme();

  return (
    <TestWrapper testId={props.testId}>
      <Styled.Header>
        {!!props.arrowButton && (
          <Styled.Button onClick={props.arrowButton.onClick} $position="1">
            <Styled.Arrow width={theme.icons.sizes.base_x3} />
          </Styled.Button>
        )}

        {!!props.children && (
          <Styled.HeaderText $style="medium_18">
            {props.children}
          </Styled.HeaderText>
        )}

        {!!props.crossButton && (
          <Styled.Button
            type="button"
            onClick={props.crossButton.onClick}
            $position="3"
          >
            <Close width={theme.icons.sizes.base_x3} />
          </Styled.Button>
        )}
      </Styled.Header>
    </TestWrapper>
  );
};
